<template>
  <b-modal
    hide-footer
    id="modal-add-user"
    ref="modal-add-user"
    size="xl"
    title="เพิ่มผู้ใช้งานเข้ากลุ่มสิทธิ์"
  >
  <div class="container">
<b-card>
      <b-row>
        <b-col cols="12">
          <CommonTable :rows="users"
          @handle-select="onSelectChange"
          > </CommonTable>
        </b-col>
      </b-row>
      <footer id="modal-transfer___BV_modal_footer_" class="modal-footer d-flex justify-content-between">
        <button type="button" class="btn btn-secondary" block @click="onCancel">
          ยกเลิก
        </button>
        <button type="button" class="btn btn-primary" block @click="onSubmit">
          เพิ่มผู้ใช้งาน
        </button>
      </footer>
    </b-card>
  </div>
    
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import vSelect from "vue-select";

import CommonTable from "./commonTableModal";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    CommonTable,
    BCard,
  },
  props: {
    users: {
      type: Array,
    },
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
      selects: [],
    };
  },
  created() {},
  methods: {
    onSubmit() {
      this.$emit("handle-submit", this.selects);
    },
    onCancel() {
      this.$refs["modal-add-user"].hide();
    },
    onSelectChange(selects) {
      this.selects = selects;
      console.log('selects', selects)
    }
  },
};
</script>

<style></style>
